<script setup lang="ts">
import { watch, computed, onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router';

import Toast from 'primevue/toast';

import AuthorizedLayout from './layouts/AuthorizedLayout.vue';
import GuestLayout from './layouts/GuestLayout.vue';

import { authService } from './utils/api/authService';

const route = useRoute();

const APP_TITLE_SUFFIX = 'Kalkulator Energetyczny projekt';

watch(route, (newRoute) => {
  const pageTitle = newRoute.meta.title as string | undefined;
  document.title = pageTitle ? `${pageTitle} | ${APP_TITLE_SUFFIX}` : APP_TITLE_SUFFIX;
});

const layout = computed(() => {
  return route.meta.layout === 'AuthorizedLayout' ? AuthorizedLayout : GuestLayout;
});

onBeforeMount(async () => {
  await authService.getCsrf();
});
</script>

<template>
  <component :is="layout">
    <RouterView />
  </component>
  <Toast class="text-black" position="bottom-right" />
</template>
